<template>
    <div class="form-success grid grid__base">
        <div class="form-success--container grid--container">
            <div class="form-success--row grid--row">
                <div class="form-success--col grid--col">
                    <h1 class="form-success--title u-reset">
                        {{ title }}
                    </h1>
                    <p class="form-success--description">{{ lead }}</p>
                    <link-list :links="[link]"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import LinkList from 'framework/components/link-list/link-list';

    export default {
        components: { LinkList },
        props: {
            title: {
                type: String,
                required: true,
            },
            lead: {
                type: String,
                required: true,
            },
            link: {
                type: Object,
                required: true,
            },
        },
    };
</script>
